import PropTypes from 'prop-types';

export default PropTypes.shape({
  component: PropTypes.func,
  routes: PropTypes.array,
});



// WEBPACK FOOTER //
// ./src/framework/routing/route-shape.js